import type { CSSProperties } from 'react';

interface CwitnesscardmodalLayoutStyleInput {
  isMobile: boolean;
  vh: number;
}

export const CWITNESSCARDMODAL_OVERLAY_STYLE = {
  position: 'fixed',
  inset: 0,
  zIndex: 60,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 32,
} as const;

export const CWITNESSCARDMODAL_BACKDROP_STYLE = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
} as const;

export const CWITNESSCARDMODAL_BACK_BUTTON_STYLE = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  zIndex: 40,
  display: 'flex',
} as const;

export const CWITNESSCARDMODAL_IMAGE_STYLE = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  filter: 'grayscale(100%)',
} as const;

export const CWITNESSCARDMODAL_CONTENT_INNER_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
} as const;

export function getCwitnesscardmodalWrapperStyle({
  isMobile,
  vh,
}: CwitnesscardmodalLayoutStyleInput): CSSProperties {
  return {
    width: '100%',
    maxWidth: 900,
    maxHeight: isMobile ? vh * 80 : vh * 90,
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  };
}

export function getCwitnesscardmodalImageContainerStyle(
  isMobile: boolean,
): CSSProperties {
  return {
    position: 'relative',
    width: isMobile ? '100%' : '50%',
    minHeight: isMobile ? 200 : 400,
    display: 'flex',
    overflow: 'hidden',
  };
}

export function getCwitnesscardmodalImageGradientStyle(
  isMobile: boolean,
): CSSProperties {
  return {
    position: 'absolute',
    inset: 0,
    backgroundImage: isMobile
      ? 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.9) 100%)'
      : 'linear-gradient(to right, transparent 0%, rgba(0,0,0,0.9) 100%)',
    display: 'flex',
  };
}

export function getCwitnesscardmodalContentContainerStyle(
  isMobile: boolean,
): CSSProperties {
  return {
    width: isMobile ? '100%' : '50%',
    padding: isMobile ? 24 : 40,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };
}

export function getCwitnesscardmodalBoxShadow(isMobile: boolean): string {
  return isMobile
    ? 'rgba(0, 0, 0, 0.81) 0px 10px 12px 0px, rgba(102, 254, 193, 0.3) 0px 20px 20px -10px'
    : 'rgba(0, 0, 0, 0.81) -10px 0px 12px 0px, rgba(102, 254, 193, 0.3) -20px 0px 20px -10px';
}
